"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Thumbsup___StyledSvg",
  componentId: "sc-162ex72-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Thumbsup(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.823 7.168a.757.757 0 00-.585-.28h-4.571v-3.11A.77.77 0 0011.905 3H9.619a.761.761 0 00-.7.47L6.83 8.445h-.26a.77.77 0 00-.761-.777H2.762A.77.77 0 002 8.444v7.778c0 .43.34.778.762.778H5.81a.77.77 0 00.761-.778v-.406l2.765 1.129c.09.036.186.055.283.055h6.095c.368 0 .684-.27.75-.639l1.524-8.555a.793.793 0 00-.165-.638zM5.048 15.444H3.524V9.222h1.524v6.222zm10.03 0H9.766L6.571 14.14V10h.762a.76.76 0 00.7-.471l2.088-4.973h1.022v3.11c0 .43.34.778.762.778h4.42l-1.246 7z",
    fill: "currentColor"
  }));
}

var _default = Thumbsup;
exports["default"] = _default;